<template>

  <!-- 最新年度の実績 -->
  <div>

    <!-- 実績値エラー表示 -->
    <div class="l-contentsSection error" 
      v-if="$v.ageAverage.regularMaleAgeAverage.$invalid 
      || $v.ageAverage.nonRegularMaleAgeAverage.$invalid
      || $v.ageAverage.regularFemaleAgeAverage.$invalid 
      || $v.ageAverage.nonRegularFemaleAgeAverage.$invalid
      || $v.ageAverage.achievementMaleAgeAverage.$invalid
      || $v.ageAverage.achievementFemaleAgeAverage.$invalid
      || $v.ageAverage.resultMemo.$invalid 
      || $v.ageAverage.actionMemo.$invalid">
      <div v-if="$v.ageAverage.regularMaleAgeAverage.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">平均年齢（正社員・男性）：</span>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.ageAverage.regularMaleAgeAverage.$invalid && !$v.ageAverage.regularMaleAgeAverage.customDoubleNum" validation="customDoubleNum" valueInt="2" valueDouble="1"/>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.ageAverage.regularMaleAgeAverage.$invalid && $v.ageAverage.regularMaleAgeAverage.customDoubleNum && !$v.ageAverage.regularMaleAgeAverage.between" validation="between" valueMin="0" valueMax="99.9"/>
      </div>
      <div v-if="$v.ageAverage.nonRegularMaleAgeAverage.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">平均年齢（非正規・男性）：</span>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.ageAverage.nonRegularMaleAgeAverage.$invalid && !$v.ageAverage.nonRegularMaleAgeAverage.customDoubleNum" validation="customDoubleNum" valueInt="2" valueDouble="1"/>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.ageAverage.nonRegularMaleAgeAverage.$invalid && $v.ageAverage.nonRegularMaleAgeAverage.customDoubleNum && !$v.ageAverage.nonRegularMaleAgeAverage.between" validation="between" valueMin="0" valueMax="99.9"/>
      </div>
      <div v-if="$v.ageAverage.regularFemaleAgeAverage.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">平均年齢（正社員・女性）：</span>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.ageAverage.regularFemaleAgeAverage.$invalid && !$v.ageAverage.regularFemaleAgeAverage.customDoubleNum" validation="customDoubleNum" valueInt="2" valueDouble="1"/>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.ageAverage.regularFemaleAgeAverage.$invalid && $v.ageAverage.regularFemaleAgeAverage.customDoubleNum && !$v.ageAverage.regularFemaleAgeAverage.between" validation="between" valueMin="0" valueMax="99.9"/>
      </div>
      <div v-if="$v.ageAverage.nonRegularFemaleAgeAverage.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">平均年齢（非正規・女性）：</span>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.ageAverage.nonRegularFemaleAgeAverage.$invalid && !$v.ageAverage.nonRegularFemaleAgeAverage.customDoubleNum" validation="customDoubleNum" valueInt="2" valueDouble="1"/>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.ageAverage.nonRegularFemaleAgeAverage.$invalid && $v.ageAverage.nonRegularFemaleAgeAverage.customDoubleNum && !$v.ageAverage.nonRegularFemaleAgeAverage.between" validation="between" valueMin="0" valueMax="99.9"/>
      </div>
      <div v-if="$v.ageAverage.achievementMaleAgeAverage.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">平均年齢（実績・男性）　：</span>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.ageAverage.achievementMaleAgeAverage.$invalid && !$v.ageAverage.achievementMaleAgeAverage.customDoubleNum" validation="customDoubleNum" valueInt="2" valueDouble="1"/>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.ageAverage.achievementMaleAgeAverage.$invalid && $v.ageAverage.achievementMaleAgeAverage.customDoubleNum && !$v.ageAverage.achievementMaleAgeAverage.between" validation="between" valueMin="0" valueMax="99.9"/>
      </div>
      <div v-if="$v.ageAverage.achievementFemaleAgeAverage.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">平均年齢（実績・女性）　：</span>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.ageAverage.achievementFemaleAgeAverage.$invalid && !$v.ageAverage.achievementFemaleAgeAverage.customDoubleNum" validation="customDoubleNum" valueInt="2" valueDouble="1"/>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.ageAverage.achievementFemaleAgeAverage.$invalid && $v.ageAverage.achievementFemaleAgeAverage.customDoubleNum && !$v.ageAverage.achievementFemaleAgeAverage.between" validation="between" valueMin="0" valueMax="99.9"/>
      </div>
      <div v-if="$v.ageAverage.resultMemo.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">実績に関するメモ　　　　：</span>
        <ValidationErrorMessage v-show="$v.ageAverage.resultMemo.$invalid && !$v.ageAverage.resultMemo.maxLength" validation="maxLength" valueLength="300" />
      </div>
      <div v-if="$v.ageAverage.actionMemo.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">具体的なアクション　　　：</span>
        <ValidationErrorMessage v-show="$v.ageAverage.actionMemo.$invalid && !$v.ageAverage.actionMemo.maxLength" validation="maxLength" valueLength="300" />
      </div>
    </div>

    <!-- 実績値入力 -->
    <div class="human-capitalt-data-wrap">
      <div class="human-capitalt-data-wrap__table01">
        <p class="l-formGroup__label u-mb10">平均年齢</p>
        <table class="human-capitalt-data-table">
          <colgroup>
            <col style="width: 50px;">
            <col>
            <col>
            <col>
          </colgroup>
          <thead>
            <tr>
              <th></th>
              <th>正社員</th>
              <th>非正規社員</th>
              <th>全社</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>男性</th>
              <td>
                <div class="human-capitalt-data-table__input has-unit">
                  <TextBox v-model.trim="$v.ageAverage.$model.regularMaleAgeAverage" type="text" name="ageAverage.regularMaleAgeAverage" class="u-tac" @input="changeInput()"></TextBox>
                  <span class="human-capitalt-data-table__unit">歳</span>
                </div>
              </td>
              <td>
                <div class="human-capitalt-data-table__input has-unit">
                  <TextBox v-model.trim="$v.ageAverage.$model.nonRegularMaleAgeAverage" type="text" name="ageAverage.nonRegularMaleAgeAverage" class="u-tac" @input="changeInput()"></TextBox>
                  <span class="human-capitalt-data-table__unit">歳</span>
                </div>
              </td>
              <td>
                <div class="human-capitalt-data-table__input has-unit is-important">
                  <TextBox v-model.trim="$v.ageAverage.$model.achievementMaleAgeAverage" type="text" name="ageAverage.achievementMaleAgeAverage" class="u-tac" @input="changeInput()"></TextBox>
                  <span class="human-capitalt-data-table__unit">歳</span>
                </div>
              </td>
            </tr>
            <tr>
              <th>女性</th>
              <td>
                <div class="human-capitalt-data-table__input has-unit">
                  <TextBox v-model.trim="$v.ageAverage.$model.regularFemaleAgeAverage" type="text" name="ageAverage.regularFemaleAgeAverage" class="u-tac" @input="changeInput()"></TextBox>
                  <span class="human-capitalt-data-table__unit">歳</span>
                </div>
              </td>
              <td>
                <div class="human-capitalt-data-table__input has-unit">
                  <TextBox v-model.trim="$v.ageAverage.$model.nonRegularFemaleAgeAverage" type="text" name="ageAverage.nonRegularFemaleAgeAverage" class="u-tac" @input="changeInput()"></TextBox>
                  <span class="human-capitalt-data-table__unit">歳</span>
                </div>
              </td>
              <td>
                <div class="human-capitalt-data-table__input has-unit is-important">
                  <TextBox v-model.trim="$v.ageAverage.$model.achievementFemaleAgeAverage" type="text" name="ageAverage.achievementFemaleAgeAverage" class="u-tac" @input="changeInput()"></TextBox>
                  <span class="human-capitalt-data-table__unit">歳</span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div><!--/human-capitalt-data-wrap__table01-->

    </div><!--/human-capitalt-data-wrap-->
    <div class="l-contentsGrid2 u-mt30">
      <div class="l-contentsGrid2__item">
        <div>
          <div class="l-formGroup">
            <label class="l-formGroup__label u-mb10">実績に関するメモ</label>
            <p v-if="this.num==0" class="l-memo-note">現状の課題や、課題に対してのアドバイスをメモしましょう。</p>
              <TextArea class="l-formGroup__textArea is-highMiddle" v-model="ageAverage.resultMemo" @input="changeInput()" ></TextArea>
          </div>
        </div>
      </div>
      <div class="l-contentsGrid2__item">
        <div class="l-contentsMemo" ref="memoEdit">
          <div class="l-formGroup">
            <div class="l-contentsMemo__title">
              <label class="l-formGroup__label">具体的なアクション</label>
              <button class="link-arrow is-normal js-memo-edit" @click="editMode()">編集する</button>
              <button class="link-arrow is-edit js-memo-exit" @click="editMode()">編集を終わる</button>
            </div>
            <p v-if="this.num==0" class="l-memo-note">今後どういった取り組みをしていくかをメモしましょう。<br>レポート画面からも入力できます。</p>
            <div class="l-contentsMemo__body">
              <div class="l-grayBox is-normal" style="min-height:108px;">
                <div>
                  <p  class="l-text" style="white-space: pre-line;" v-html="repalceLink(ageAverage.actionMemo)"></p>
                </div>
              </div>
            </div>
            <TextArea class="l-formGroup__textArea is-highMiddle is-edit" v-model="ageAverage.actionMemo" @input="changeInput()"></TextArea>
          </div>
        </div>
      </div>
    </div><!--/l-contentsGrid2-->
  </div>
</template>

<script>
import TextBox from '@/components/parts/form/TextBox.vue';
import ValidationErrorMessage from '@/components/parts/form/ValidationErrorMessage.vue';
import TextArea from '@/components/parts/form/TextArea.vue';
import { between, maxLength } from 'vuelidate/lib/validators';
//import Currency from '@/components/parts/human_capital/parts/Currency.vue';

export default {
  components: {
    TextBox,
    ValidationErrorMessage,
    TextArea,
//    Currency,
  },
  props: {
    // 表示年度の平均年齢データ
    ageAverage: {},
    num: null,
  },
  data() {
    return {
      isAnswerChanged:false,
      unit1: "年",
    }
  },
  computed: {
  },
  validations: {
    ageAverage: {
      regularMaleAgeAverage : { 
        between: between(0,99.9), 
        customDoubleNum: (value) => {
          if ( value != null && value.length == 0 ) return true;
          if ( value != null ) return /^([1-9][0-9]{0,1}|0)(\.[0-9]{1,1})?$/.test(value);
          return true;
        }
      }, // 平均年齢（正規・男性）
      nonRegularMaleAgeAverage : {
        between: between(0,99.9),
        customDoubleNum: (value) => {
          if ( value != null && value.length == 0 ) return true;
          if ( value != null ) return /^([1-9][0-9]{0,1}|0)(\.[0-9]{1,1})?$/.test(value);
          return true;
        }
      },  // 平均年齢（非正規・男性）
      regularFemaleAgeAverage : {
        between: between(0,99.9),
        customDoubleNum: (value) => {
          if ( value != null && value.length == 0 ) return true;
          if ( value != null ) return /^([1-9][0-9]{0,1}|0)(\.[0-9]{1,1})?$/.test(value);
          return true;
        }
      },  // 平均年齢（正規・男性）
      nonRegularFemaleAgeAverage : { 
        between: between(0,99.9), 
        customDoubleNum: (value) => {
          if ( value != null && value.length == 0 ) return true;
          if ( value != null ) return /^([1-9][0-9]{0,1}|0)(\.[0-9]{1,1})?$/.test(value);
          return true;
        }
      },  // 平均年齢（非正規・女性）
      achievementMaleAgeAverage : {
        between: between(0,99.9), 
        customDoubleNum: (value) => {
          if ( value != null && value.length == 0 ) return true;
          if ( value != null ) return /^([1-9][0-9]{0,1}|0)(\.[0-9]{1,1})?$/.test(value);
          return true;
        }
      },  // 平均年齢（実績・男性）
      achievementFemaleAgeAverage : {
        between: between(0,99.9),
        customDoubleNum: (value) => {
          if ( value != null && value.length == 0 ) return true;
          if ( value != null ) return /^([1-9][0-9]{0,1}|0)(\.[0-9]{1,1})?$/.test(value);
          return true;
        }
      },  // 平均年齢（実績・女性）
      resultMemo: { maxLength: maxLength(300) }, // 実績メモ
      actionMemo: { maxLength: maxLength(300) }, // アクションメモ
    }
  },
  watch: {
    ageAverage() {
      this.inputAgeAverage();
    }
  },
  created: function () {

  },
  mounted() {

  },
  methods: {
    inputAgeAverage() {
      this.$emit("change-age-average", {
        ageAverage: this.ageAverage,
        num: this.num,
      });
    },
    // アクションメモの編集モード切替
    editMode(isEdit){
      const memoElm = this.$refs.memoEdit
      if ( isEdit == null || memoElm.classList.contains("is-edit") ){
        memoElm.classList.toggle("is-edit");
      }
    },
    // 文字列中のURLをaタグに変換する
    repalceLink(text) {
      return text ? text.replace(/(https?:\/\/[^\s]*)/g, "<a href='$1'style='text-decoration: underline; color: #0070be;' target='_blank' rel='noopener noreferrer'>$1</a>") : '';
    },
    // 編集フラグの取得（メイン画面の画面遷移時に呼び出されてチェックする）
    getIsAnswerChanged(){
      return this.isAnswerChanged; 
    },
    // 入力データ編集フラグ
    changeInput(){
      this.isAnswerChanged = true
    },
    setIsAnswerChanged(flag){
      this.isAnswerChanged = flag;
    }
  }
}

</script>
